import {OfferCheckApiRequestParams} from '../types/OfferCheck'

/**
 * Constructs the request parameters for the offer check API.
 * Merges default headers with custom headers and the provided API key.
 * @param url - The API endpoint URL.
 * @param experimentApiKey - The BoVio API key.
 * @param headers - Optional custom headers to include in the request.
 * @returns The request parameters for the offer check API.
 */
export const getOfferCheckApiRequestParams = (
  url: string,
  experimentApiKey: string,
  headers?: Record<string, string>
): OfferCheckApiRequestParams => ({
  url,
  experimentApiKey,
  headers: {
    Accept: 'application/json',
    'X-Client-User-Agent': `checkout/${process.env.NEXT_PUBLIC_APP_VERSION}`,
    ...headers
  }
})
